<template>
  <div style="margin:20px">
    <div style="width: 100%; background-color: #eee; border: 1px dotted grey; margin-bottom: 25px;">
      <span style="font-size: 26px; font-weight: bold">Intrastate Booking Report</span><br/>
      <span style="font-style: italic; font-size: 18px">this report shows bookings with all segments in the same state.</span>
    </div>
    <div style="position: relative; font-weight: bold; font-size: 24px" class="align-right d-flex align-items-center justify-content-center">
      <a href="#" class="white-link" v-on:click.prevent="shift_detail_graph_date(-1)"><</a>
      &nbsp;<date-picker style="font-size: 20px; font-weight: bold; width:140px" v-model="details_fromDate" :config="options" :placeholder="details_fromDate"/>
      &nbsp;to&nbsp;<date-picker style="font-size: 20px; font-weight: bold; width:140px" v-model="details_toDate" :config="options" :placeholder="details_toDate"/>
      &nbsp;<a href="#" class="white-link" v-on:click.prevent="shift_detail_graph_date(1)">></a>
      &nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;
      <span v-if="state_options.length > 2"><b-form-select v-model="selected_state" :options="state_options" style="font-size: 20px; font-weight: bold; width:100px"/>&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;</span>
      <b-button v-on:click.prevent="load_data()" :disabled="loading">Run Report</b-button>
      &nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;
      Filter Results&nbsp;<b-form-input style="width: 200px" v-model="booking_filter"/>
      &nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;
      <div class="d-flex align-items-center justify-content-center">
        <b-button size="md" variant="success" @click="download">Download</b-button>
      </div>
    </div>
    <div v-if="items_full.length > 0">
      <div>
        <div class="row" style="margin:30px; font-weight: bold; font-size: 24px;">
          <div class="col" style="border: 1px solid grey;">{{items.length}} of {{items_full.length}}</div>
        </div>
      </div>
      <b-table :busy="loading" sticky-header="70vh" bordered :items="items" :fields="fields" style="font-size:18px;" :current-page="currentPage" :per-page="perPage">

        <template #table-busy>
          <div class="text-center text-danger my-2">
            <b-spinner class="align-middle"></b-spinner>
          </div>
        </template>

        <template slot="bookingID" slot-scope="row">
          <router-link target="_blank" style="font-weight: bold;" :to="{ path: '/actuals_tbn?booking_id=' + row.item.booking_hash }">{{ row.item.bookingID }}</router-link>
        </template>

<!--        <template slot="pickup_time" slot-scope="row">-->
<!--          {{row.item.pickup_time | formatDateTimeSmall}}-->
<!--        </template>-->

<!--        <template slot="dropoff_time" slot-scope="row">-->
<!--          {{row.item.dropoff_time | formatDateTimeSmall}}-->
<!--        </template>-->

        <template slot="distance" slot-scope="row">
          <span v-if="row.item.distance">
            total: {{row.item.distance}}<br/>
            <span v-for="state_distance in row.item.state_distances">
              {{state_distance.jurisdiction}}: {{state_distance.distance}}<br/>
            </span>
          </span>
        </template>

      </b-table>
      <b-row>
        <b-col>
          <b-pagination
              v-model="currentPage"
              :total-rows="items.length"
              :per-page="perPage"
              align="center"
          >
          </b-pagination>
        </b-col>
      </b-row>
    </div>
    <div v-else-if="loading">
      <br/><br/>
      <b-spinner style="width: 3rem; height: 3rem;" label="Loading..."></b-spinner>
    </div>

  </div>

</template>
<script>
import {api_url, get_tbn_intrastate_booking_report} from '../networking/tbn_apis'
import {mapState} from "vuex"
import {justDate} from '../helpers/dates'
import moment from 'moment'
import axios from "axios";

export default {
  name: 'intrastate_booking_report_tbn',

  components: {
  },

  data() {
    return {
      booking_filter: '',
      items: [],
      items_full: [],
      selected_state: '',
      state_options: [],
      summary: [],
      loading: false,
      details_fromDate: justDate(moment().subtract(1, 'days')),
      details_toDate: justDate(moment().subtract(1, 'days')),
      totalRows: 1,
      currentPage: 1,
      perPage: 100,
      pages: [],
      fields_all: [],
      fields: [
        { key: 'bookingID', label: 'Booking ID', sortable: true},
        { key: 'route_name', label: 'Route', sortable: true, thStyle: { width: "300px" }},
        { key: 'vehicle', label: 'Vehicle', sortable: true},
        { key: 'state', label: 'State', sortable: true},
        { key: 'pickup_time', label:'First Pickup', sortable: true, thStyle: { width: "150px" }},
        { key: 'pickup', label:'First Pickup Addr', sortable: true,  thStyle: { width: "350px" }},
        { key: 'dropoff_time', label:'Last Dropoff', sortable: true, thStyle: { width: "150px" }},
        { key: 'dropoff', label:'Last Dropoff Addr', sortable: true,  thStyle: { width: "350px" }},
        // { key: 'distance', label:'Distance', sortable: true},
      ],
      options: {
        format: 'MM-DD-YYYY',
        useCurrent: true,
        minDate: moment().subtract(90, 'days'),
        maxDate: moment().add(90, 'days'),
        keepOpen: false,
        showClear: true,
        showClose: true,
      },
    }
  },
  created() {

  },
  methods: {
    async load_data() {
      this.loading = true
      try {
        const {value: {data = []}} = await get_tbn_intrastate_booking_report(this.user.tenant, moment(this.details_fromDate, 'MM-DD-YYYY').format('YYYY-MM-DD'), moment(this.details_toDate, 'MM-DD-YYYY').format('YYYY-MM-DD'))
        this.summary = data.summary
        moment.tz.setDefault(this.summary.timezone)
        this.items = data.results
        this.items_full = data.results
        this.state_options = data.summary.state_options
        this.filter_items()
      } catch(e){
        this.$emit('showAlert', 'error retrieving data, try logging in again or contact support if needed', 'danger', 5000)
      }
      this.loading = false
    },
    async shift_detail_graph_date(shift) {
      this.details_fromDate = moment(this.details_fromDate, 'MM-DD-YYYY').add(shift, 'days').format('MM-DD-YYYY');
    },
    filter_items() {
      this.items = this.items_full
      if (this.booking_filter)
        this.items = this.items.filter(item => (this.contains(item.bookingID, this.booking_filter) || this.contains(item.route_name, this.booking_filter) || this.contains(item.pickup, this.booking_filter) || this.contains(item.dropoff, this.booking_filter) || (this.contains(item.vehicle, this.booking_filter))))
      if (this.selected_state)
        this.items = this.items.filter(item => item.state == this.selected_state)
    },
    contains(val1, val2) {
      if (val1 != null) {
        return val1.toLowerCase().indexOf(val2.toLowerCase()) != -1;
      }
      return false;
    },
    async download(){
      this.$emit('showAlert', 'processing download request', 'info', 5000)
      axios.defaults.headers.common.Accept = {}
      axios.post(
          `${api_url}tbn/reports/actuals/intrastate_bookings/download`,
          {
            tenant: this.user.tenant,
            fromDate: moment(this.details_fromDate, 'MM-DD-YYYY').format('YYYY-MM-DD'),
            toDate: moment(this.details_toDate, 'MM-DD-YYYY').format('YYYY-MM-DD'),
          }, {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('jwt')}`,
              Accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            },
            responseType: 'blob'
          }
      ).then((response) => {
        axios.defaults.headers.common.Accept = 'application/json'
        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute(
            'download',
            `intrastate-${this.details_fromDate}-${this.details_toDate}.csv`
        )
        document.body.appendChild(link)
        link.click()
        this.$emit('showAlert', 'download complete', 'success', 5000)
      }).catch(e => {
        axios.defaults.headers.common.Accept = 'application/json'
        this.$emit('showAlert', 'data could not be downloaded.', 'danger')
      })
    },
  },
  computed:{
    ...mapState({
      user: state => state.profile.user
    }),
  },
  watch: {
    user: {
      deep: true,
    },
    booking_filter() {
      this.filter_items()
    },
    selected_state() {
      this.filter_items()
    },
  }
}
</script>

<style scoped>

tr:nth-child(even) {
  background-color: #f2f2f2 !important;
}
.arrows {font-size: 22px; font-weight: bold; color: var(--fi-rail-accent) !important }

</style>
